exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-import-designer .import-refresh-btn[data-v-5ba8867e]{margin-top:.75rem}", ""]);

// exports
